export default {
    "available_periods": {
        "1": "Месяц",
        "3": "Квартал",
        "6": "Полугодие",
        "12": "Год"
    },
    "available_sections_for_period": {
        "1": [],
        "3": [],
        "6": [],
        "12": []
    },
    "card_limit_for_user_per_period": 0,
    "cards_create_info_template": "componentsCompany/level/CardsCreateInfo",
    "card_recount_bonus_service": null,
    "is_card_next_and_previous_buttons": true,
    "card_ar_history_behavior_ignore_fields": [],
    "card_ar_history_relations": [],
    "cards_visible_permissions_criteria_map": {
        "card.see_if_participate": "app\\domain\\Card\\criteria\\returnInNewQuery\\CardIParticipateCriteria",
        "card.see_my": "app\\domain\\Card\\criteria\\CardMyCriteria",
        "card.see_subordinates": "app\\domain\\Card\\criteria\\returnInNewQuery\\CardAllSubordinatesCriteria",
        "card.see_chiefs": "app\\domain\\Card\\criteria\\returnInNewQuery\\CardMyChiefsCriteria",
        "card.see_top_level_cards_on_stage_comment": "app\\build\\level\\card\\criteria\\CardTopLevelOnStageCommentCriteria",
        "card.see_top_level_this_year_finished": "app\\build\\level\\card\\criteria\\CardThisYearTopLevelFinishedCriteria"
    },
    "cards_search_criteria": [
        "app\\domain\\Card\\criteria\\CardsUserFiredCriteria"
    ],
    "cards_section_elements_search_criteria": [
        "app\\build\\level\\card\\criteria\\LevelCardElementHiddenCriteria"
    ],
    "cards_search_expand": [],
    "cards_page_filters": {
        "template": "componentsCompany/level/CardsPageFilters",
        "card_search_request_class": "app\\build\\level\\card\\criteria\\LevelCardSearchRequest",
        "search_fields": {
            "cards.id": {
                "condition": "=",
                "type": "number"
            },
            "users.persnum": {
                "relation": "user"
            },
            "users.last_name": {
                "relation": "user"
            },
            "users.first_name": {
                "relation": "user"
            },
            "users.middle_name": {
                "relation": "user"
            },
            "users.position": {
                "relation": "user"
            },
            "users.subdivision": {
                "relation": "user"
            }
        },
        "default_sort_params": {
            "attributes": {
                "id": {
                    "asc": {
                        "cards.id": 4
                    },
                    "desc": {
                        "cards.id": 3
                    }
                },
                "0": "year",
                "1": "bonus",
                "user.persnum": {
                    "asc": {
                        "users.persnum": 4
                    },
                    "desc": {
                        "users.persnum": 3
                    }
                },
                "user.last_name": {
                    "asc": {
                        "users.last_name": 4
                    },
                    "desc": {
                        "users.last_name": 3
                    }
                },
                "user.subdivision": {
                    "asc": {
                        "users.subdivision": 4
                    },
                    "desc": {
                        "users.subdivision": 3
                    }
                },
                "user.company": {
                    "asc": {
                        "users.company": 4
                    },
                    "desc": {
                        "users.company": 3
                    }
                },
                "user.position": {
                    "asc": {
                        "users.position": 4
                    },
                    "desc": {
                        "users.position": 3
                    }
                },
                "user.grade": {
                    "asc": {
                        "users.grade": 4
                    },
                    "desc": {
                        "users.grade": 3
                    }
                },
                "user.directChief.full_name dc": {
                    "asc": {
                        "dc.last_name": 4
                    },
                    "desc": {
                        "dc.last_name": 3
                    }
                }
            },
            "defaultOrder": {
                "id": 3
            }
        }
    },
    "cards_page_columns": [
        {
            "label": "Карта №",
            "prop": "id",
            "width": 110
        },
        {
            "label": "ФИО",
            "template": "components/tableColumnTemplates/cards/RouterLinkToCardColumnTemplate",
            "prop": "user.last_name"
        },
        {
            "label": "Должность",
            "prop": "user.position"
        },
        {
            "label": "Дирекция",
            "prop": "user.subdivision_1"
        },
        {
            "label": "Подразделение 2",
            "prop": "user.subdivision_2"
        },
        {
            "label": "Подразделение 3",
            "prop": "user.subdivision_3"
        },
        {
            "label": "Год",
            "prop": "year",
            "width": 80
        },
        {
            "label": "Период",
            "template": "components/tableColumnTemplates/cards/PeriodWithIndexColumnTemplate",
            "width": 100
        },
        {
            "label": "Текущий этап",
            "template": "components/tableColumnTemplates/cards/CurrentStageColumnTemplate",
            "prop": "currentStage.type"
        },
        {
            "label": "Текущий шаг",
            "template": "components/tableColumnTemplates/cards/CurrentNegotiationColumnTemplate"
        },
        {
            "label": "% премии",
            "prop": "bonus",
            "width": 120
        },
        {
            "template": "components/tableColumnTemplates/cards/ActionsColumnTemplate",
            "width": 80,
            "align": "right",
            "on": {
                "delete-card": "(e) => { templateData.$emit(\"delete-card\", e) }"
            }
        }
    ],
    "card_header_template": "componentsCompany/level/CardHeader",
    "card_selectable_page_columns": []
}